import { forwardRef } from 'react';
import clsx from 'clsx';

const PhoneInput = forwardRef(
  (
    {
      label,
      error,
      helperText,
      fullWidth = false,
      className = '',
      containerClassName = '',
      maxLength = 15,
      ...props
    },
    ref
  ) => {
    const inputClasses = clsx(
      'px-4 py-2 border rounded-lg transition-colors duration-200',
      'focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent',
      'disabled:bg-gray-100 disabled:cursor-not-allowed',
      error
        ? 'border-secondary-500 focus:ring-secondary-400'
        : 'border-gray-300',
      'bg-white text-primary-900',
      'placeholder:text-gray-400',
      fullWidth && 'w-full',
      className
    );

    const handleKeyPress = (e) => {
      // Allow only numbers, backspace, delete, arrow keys, tab
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
      if (!allowedKeys.includes(e.key) && !/^[0-9]$/.test(e.key)) {
        e.preventDefault();
      }
    };

    const handlePaste = (e) => {
      // Get pasted data
      const pastedData = e.clipboardData.getData('text');
      // Check if pasted data contains only numbers
      if (!/^[0-9]+$/.test(pastedData)) {
        e.preventDefault();
      }
    };

    return (
      <div className={clsx('flex flex-col', fullWidth && 'w-full', containerClassName)}>
        {label && (
          <label className="mb-1.5 text-sm font-medium text-primary-700">
            {label}
          </label>
        )}
        
        <input
          ref={ref}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={maxLength}
          className={inputClasses}
          onKeyPress={handleKeyPress}
          onPaste={handlePaste}
          {...props}
        />
        
        {(error || helperText) && (
          <p
            className={clsx(
              'mt-1.5 text-sm',
              error ? 'text-secondary-600' : 'text-gray-500'
            )}
          >
            {error || helperText}
          </p>
        )}
      </div>
    );
  }
);

PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
